import type { RequestService } from '../estoffice/common/request.module';
import type { RootScope } from '../types';
import type { FilterSpec } from './queryBuilder';
import type { SectionFilterResponse } from './types';

import $ from 'jquery';

import { apiUrls } from '../estoffice/common/apiUrls';

/**
 * Implements unit filtering logic
 */
export class UnitSearchPanelFilterService {
  static $inject = ['$rootScope', 'request'];

  constructor(
    private $rootScope: RootScope,
    private request: RequestService,
  ) {}

  /**
   * Performs API request with currently active filter applied
   */
  requestFilter({
    sectionId,
    publicMode,
    byHouseMode,
    filters,
  }: {
    sectionId: string;
    publicMode: boolean;
    byHouseMode: boolean;
    filters: FilterSpec[];
  }): void {
    if (!filters.length) {
      this.reset();

      return;
    }

    let url = apiUrls.filter.replace('{{sectionId}}', sectionId);

    const filter: { [key: string]: any } = {};

    if (publicMode) {
      url = url.replace('filter', 'public-filter');
      filter.public = 1;
    }

    if (byHouseMode) {
      filter.byHouse = 1;
    }

    for (const item of filters) {
      filter[item.name] = item.value;
    }

    this.request.get(
      url,
      filter,
      ({ data: { result } }: { data: SectionFilterResponse }) => {
        this.$rootScope.filterStart = true;

        const fullMatch: string[] = [];
        const closeMatch: string[] = [];

        if (result.current.units && result.current.units.length) {
          fullMatch.push(...result.current.units);
        }

        if (result.current.close_match && result.current.close_match.length) {
          closeMatch.push(...result.current.close_match);
        }

        if (result.neighbour && Object.keys(result.neighbour).length) {
          Object.values(result.neighbour).forEach((value) => {
            if (value.units && value.units.length) {
              fullMatch.push(...value.units);
            }

            if (value.close_match && value.close_match.length) {
              closeMatch.push(...value.close_match);
            }
          });
        }

        $('.b-house__unit').removeClass(
          '-matches_full -matches_partly -matches_none',
        );

        fullMatch.forEach((id) => {
          $(`.b-house__unit[data-unit-id=${id}]`).addClass('-matches_full');
        });

        closeMatch.forEach((id) => {
          $(`.b-house__unit[data-unit-id=${id}]`).addClass('-matches_partly');
        });

        $('.b-house__unit').each(function () {
          if (
            $(this).hasClass('-matches_full') ||
            $(this).hasClass('-matches_partly')
          ) {
            return;
          }

          $(this).addClass('-matches_none');
        });
        this.$rootScope.countFilter = result.current.counter;
        this.$rootScope.countFilterMatch = result.current.close_match.length;
        this.$rootScope.filterObjects = result.objects;
        this.$rootScope.neighbour = {
          ...result.neighbour,
          exact: Object.keys(result.neighbour).reduce(
            (previous, key) => previous + result.neighbour[key].counter,
            0,
          ),
          close: Object.keys(result.neighbour).reduce((previous, key) => {
            if (result.neighbour[key].close_match) {
              return previous + result.neighbour[key].close_match.length;
            }

            return previous;
          }, 0),
        };
        this.$rootScope.current = result.current;
      },
    );
  }

  /**
   * Resets all currently active filters to defaults
   */
  reset(): void {
    this.$rootScope.filterStart = false;
    this.$rootScope.countFilter = false;
    this.$rootScope.countFilterMatch = false;
    this.$rootScope.filterObjects = null;
    this.$rootScope.neighbour = null;
    this.$rootScope.current = null;

    $('.b-house__unit').removeClass(
      '-matches_full -matches_partly -matches_none',
    );
  }
}
